<template>
  <div class="container-fluid" v-html="theme.content"></div>
</template>

<script>
export default {
  props: {
    theme: Object,
  },

  mounted() {
    this.$nextTick(() => {
      window.customScripts();
    });
  },
};
</script>

<style lang="scss"></style>
